import DailyStatsTableCard from './DailyStatsTableCard';

export default DailyStatsTableCard;
